import { merge, get, set, clone } from 'lodash';
import { ACTIONALBUM, ADMIN } from '../../../actionTypes';
let initState = {
	adminList: []
};
export function AdminManageReducers(state = initState, action) {
	switch (action.type) {
		case ADMIN.SET_ADMIN_LIST: {
			// console.log ( "payload..." , action.payload);
			let adminList = get(action, 'payload.data', []);
			state.adminList = clone(adminList);
			return merge({}, state, {});
		}
		default:
			return state;
	}
}
